import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { NotificationService } from '../../service/notification.service';
import { Subscription } from 'rxjs';
import { NotificationType } from '../../enum/notification-type.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ManageUserService } from 'src/app/service/manage-user.service';
import { AuditLoginModel } from '../../models/userManagementModel/auditlogin.model';
import { AuditLoginService } from 'src/app/service/auditlogin.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-view-log-ins',
  templateUrl: './view-log-ins.component.html',
  styleUrls: ['./view-log-ins.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ViewLogInsComponent implements OnInit, AfterViewInit {
  private subscriptions: Subscription[] = [];
  public refreshing: boolean;

  public employeeId: string;
  public fname: string;
  public lname: string;

  auditLoginModel = new AuditLoginModel(0, null, '', '', '', '');

  public displayedColumns = ['loggedinTime', 'action'];
  public dataSource = new MatTableDataSource<AuditLoginModel>();


  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  supervisorNamesSet = new Set<string>();

  constructor(private router: Router, private manageUserService: ManageUserService,
    private auditLoginService: AuditLoginService, private notificationService: NotificationService,
    private exportExcelService: ExportExcelService) { }

  ngOnInit(): void {
    this.employeeId = this.manageUserService.selectedUserModel.employeeId;
    this.fname = this.manageUserService.selectedUserModel.first_name;
    this.lname = this.manageUserService.selectedUserModel.last_name;
    console.log("employeeId = " + this.employeeId);
    console.log("fname = " + this.fname);
    this.getLoginsActivityList();
  }

  public getLoginsActivityList(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.auditLoginService.getLoginsActivityList(this.employeeId).subscribe(
        (response: AuditLoginModel[]) => {
          console.log(JSON.stringify(response));
          this.dataSource.data = response as AuditLoginModel[];
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  ExportTOExcel() {
    this.exportExcelService.exportFromHtmlTable(this.table.nativeElement, 'Logins-Data');
  }

  public redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  public customSort = (event) => {
    console.log(event);
  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


}
